import { render } from "./form1.vue?vue&type=template&id=040136a1&scoped=true"
import script from "./form1.vue?vue&type=script&lang=js"
export * from "./form1.vue?vue&type=script&lang=js"

import "./form1.vue?vue&type=style&index=0&id=040136a1&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040136a1"]])

export default __exports__